__turbopack_context__.v({
  "extraFiles": "DemoContentLoading-module__mgqr6a__extraFiles",
  "extraVariants": "DemoContentLoading-module__mgqr6a__extraVariants",
});
